import DialogContent from '@mui/material/DialogContent';
import { styled } from '@mui/material/styles';

const StyledDialogContent = styled(DialogContent)({
  padding: '0 24px',
  marginTop: '-8px',
});

export default StyledDialogContent;
